import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from "react-redux";
import SidebarLogout from './SidebarLogout'
import SidebarCloseButton from './SidebarCloseButton'

export default function PatientMenu(props) {
  const authData = useSelector((state) => state.auth);

  return (
    <>
     <aside className="main-sidebar">
        <section className="sidebar position-relative">
          <SidebarCloseButton />
          <div className="multinav">
            <div className="multinav-scroll">
              <ul className="sidebar-menu" data-widget="tree">
                <li>
                  <Link to="/patient-dashboard">
                    <i className="icon-Layout-4-blocks">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Dashboard</span> 
                  </Link> 
                </li>

                <li className="">
                  <Link to="/instructions">
                    <i className="icon-Diagnostics">
                      <span className="path1"></span>
                      <span className="path2"></span>
                      <span className="path3"></span>
                    </i>
                    <span className="sidebar-menu__label">Patient Guidelines</span> 
                  </Link>
                   
                </li>
                <li>
                  <Link
                   to={`/add-bp-records/${authData.user.id}/?color=red`}  uType="self">                  
                    <i className="icon-Compiling">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Add Self BP Records</span>                    
                  </Link>                   
                </li>

                <li>
                  <Link to={`/add-family-members/${authData.user.id}`}>
                    <i className="icon-Barcode-read">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Add Family Member</span>
                  </Link>
                </li>

              
                <li>
                  <Link to="/family-members">
                    <i className="icon-Barcode-read">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">View Family Member</span>
                  </Link>
                </li>



               
               
                {/* <li>
                  <a href="reports.html">
                    <i className="icon-Settings-1">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Home BP Monitoring Study</span>
                  </a>
                </li> */}
               
                {/* <li className="header">Reports</li> */}
                {/* <li >
                  <Link to="/contact">
                    <i className="icon-Library">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Contact</span> 
                  </Link>
                  
                </li> */}
                <li>
                  <Link to="/change-password">
                    <i className="icon-Lock-overturning">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Change Password</span>
                  </Link>
                </li>
              </ul>
              <SidebarLogout />
            </div>
          </div>
        </section>
      </aside>
       
   </>
  )
}
